
/*========================================
        Imports!!!
=========================================*/

/*--BrowserRouter--*/

import { Link, useNavigate } from 'react-router';
import { useState } from 'react';


/*--css--*/
import '../assets/css/meat.css';
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';



/*--cows footer--*/

import mu1 from '../assets/cowsss/lower/3.webp';
import mu2 from '../assets/cowsss/lower/5.webp';
import mu3 from '../assets/cowsss/lower/6.webp';
import mu4 from '../assets/cowsss/lower/7.webp';
import mu5 from '../assets/cowsss/lower/4.webp';
import mu6 from '../assets/cowsss/lower/1.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/insta.webp';

/*--meat--*/
import MeatPart from '../assets/img/PartsofBeef.png';

import chuck from '../assets/meat/lower/chuck.webp';
import brisket from '../assets/meat/lower/brisket.webp';
import flank from '../assets/meat/lower/flank.webp';
import lion from '../assets/meat/lower/lion.webp';
import plate from '../assets/meat/lower/plate.webp';
import rib from '../assets/meat/lower/rib.webp';
import round from '../assets/meat/lower/round.webp';
import shank from '../assets/meat/lower/shank.webp';

/*--logo--*/
import logo from '../assets/img/logo.png';

/*--higher--*/

/*--cows footer--*/

import mu1h from '../assets/cowsss/higher/3.webp';
import mu2h from '../assets/cowsss/higher/5.webp';
import mu3h from '../assets/cowsss/higher/6.webp';
import mu4h from '../assets/cowsss/higher/7.webp';
import mu5h from '../assets/cowsss/higher/4.webp';
import mu6h from '../assets/cowsss/higher/1.webp';

/*--meat--*/
import chuckh from '../assets/meat/higher/chuck.webp';
import brisketh from '../assets/meat/higher/brisket.webp';
import flankh from '../assets/meat/higher/flank.webp';
import lionh from '../assets/meat/higher/lion.webp';
import plateh from '../assets/meat/higher/plate.webp';
import ribh from '../assets/meat/higher/rib.webp';
import roundh from '../assets/meat/higher/round.webp';
import shankh from '../assets/meat/higher/shank.webp';


/*========================================
        Functions!!!
=========================================*/



function Middle({Changing4}) {
  return (
    <>
      <article className='MeatContainer'>
        <article className='MeatContent'>
          {/*--firstsection--*/}
          <section className='firstSect'>
            <Row>
              <Col className='MeatImage'>
                <h1>Dlaczego mięso z Highlandera jest najlepsze?</h1>
                <div className="meat-image-container" />
              </Col>
            </Row>
            <Row>
              <Col  className='MeatDescription'>
                <p>Bydło Highland to jedna z najstarszych i najczystszych ras na świecie, znana nie tylko ze swoich charakterystycznych długich rogów i kudłatej sierści, ale także z wyjątkowej jakości mięsa. Hodowane naturalnie i powoli w bezstresowych warunkach, bydło Highland produkuje wołowinę, która wyróżnia się zarówno smakiem, jak i wartościami odżywczymi.</p>
                <p>Mięso Highlandera jest chude, a jednocześnie niezwykle delikatne i pełne smaku. Dzięki naturalnej diecie zwierząt składającej się z trawy i ziół, wołowina ma wyraźny, bogaty smak, który nie wymaga intensywnego przyprawiania. Ma również niższą zawartość cholesterolu i tłuszczu w porównaniu do konwencjonalnej wołowiny, co czyni ją zdrowszym wyborem bez uszczerbku dla jakości.</p>
              </Col>
            </Row>
          </section>
          {/*--meat parts section--*/}
          <section className='MeatParts'>
            <Row>
              <Col>
                <h2>Podstawowe kawałki mięsa wołowego</h2>
                <img src={MeatPart} alt="meat parts"/>
                <section className='list'>
                  <h3>Istnieje osiem podstawowych cięć:</h3>
                  <ul>
                    <li><a href="#Chuck">Chuck (Karkówka)</a></li>
                    <li><a href="#Brisket">Brisket (Mostek)</a></li>
                    <li><a href="#Rib">Rib (Żeberka)</a></li>
                    <li><a href="#Plate">Plate (Szponder)</a></li>
                    <li><a href="#Loin">Loin (Rostbef)</a></li>
                    <li><a href="#Flank">Flank (Łata)</a></li>
                    <li><a href="#Round">Round (Udziec)</a></li>
                    <li><a href="#Shank">Shank (Podudzie)</a></li>
                  </ul>
                </section>
              </Col>
            </Row>
            {/*--Chuck--*/}
            <hr/>
            <Row className='Cuts' id="Chuck">
              <h2>Karkówka</h2>
              <p>
                Pochodzi z przedniej części tuszy, obejmując okolice łopatki i szyi. Mięso z karkówki jest bogate w smak i doskonale nadaje się do duszenia, gotowania oraz mielenia na mięso mielone.
              </p>
              <img onLoad={Changing4} src={chuck} alt="czesc miesa" id="chuck"/>
            </Row>
            {/*--Brisket--*/}
            <hr/>
            <Row className='Cuts' id="Brisket">
              <h2>Mostek</h2>
              <p>
                Znajduje się w dolnej części klatki piersiowej. To mięso wymaga długiego, powolnego gotowania, takiego jak duszenie czy wędzenie, aby stało się miękkie i soczyste.
              </p>
              <img onLoad={Changing4} src={brisket} alt="czesc miesa" id="brisket"/>
            </Row>
            {/*--Rib--*/}
            <hr/>
            <Row className='Cuts' id="Rib">
              <h2>Żeberka</h2>
              <p>
                Żeberka to część znajdująca się w środkowej części tuszy, obejmująca żebra od 6 do 12. Są znane ze swojej soczystości i intensywnego smaku. Idealne do pieczenia, grillowania czy duszenia.
              </p>
              <img onLoad={Changing4} src={rib} alt="czesc miesa" id="rib"/>
            </Row>
            {/*--Plate--*/}
            <hr/>
            <Row className='Cuts' id="Plate">
              <h2>Szponder</h2>
              <p>
                Znajduje się poniżej żeber, w okolicy brzucha. Mięso z tej części ma wyraźny smak i często jest wykorzystywane do przygotowania krótkich żeberek oraz mięsa mielonego. Najlepiej nadaje się do duszenia.
              </p>
              <img onLoad={Changing4} src={plate} alt="czesc miesa" id="plate"/>
            </Row>
            {/*--Loin--*/}
            <hr/>
            <Row className='Cuts' id="Loin">
              <h2>Rostbef</h2>
              <p>
                Pochodzi z grzbietowej części tuszy, pomiędzy żebrami a udźcem. To jedno z najbardziej cenionych mięs wołowych, znane ze swojej delikatności i braku tłuszczu. Idealne do szybkiego smażenia, grillowania czy pieczenia.
              </p>
              <img onLoad={Changing4} src={lion} alt="czesc miesa" id="lion"/>
            </Row>
            {/*--Flank--*/}
            <hr/>
            <Row className='Cuts' id="Flank">
              <h2>Łata wołowa</h2>
              <p>
                Znajduje się w dolnej części brzucha, pomiędzy żebrami a udźcem. To długi, płaski kawałek mięsa o wyraźnym włóknistym układzie. Jest chudy i może być twardy, dlatego często jest marynowany przed szybkim grillowaniem lub smażeniem.
              </p>
              <img onLoad={Changing4} src={flank} alt="czesc miesa" id="flank"/>
            </Row>
            {/*--Round--*/}
            <hr/>
            <Row className='Cuts' id="Round">
              <h2>Udziec</h2>
              <p>
                Pochodzi z tylnej części tuszy, obejmując okolice udźca. Mięso z tej części jest chude i może być twarde, dlatego najlepiej nadaje się do pieczenia, duszenia lub krojenia na cienkie plastry do smażenia.
              </p>
              <img onLoad={Changing4} src={round} alt="czesc miesa" id="round"/>
            </Row>
            {/*--Shank--*/}
            <hr/>
            <Row className='Cuts' id="Shank">
              <h2>Podudzie</h2>
              <p>
                Znajduje się w dolnych partiach nóg, zarówno przednich, jak i tylnych. Mięso z podudzia jest bardzo chude i wymaga długiego, powolnego gotowania, takiego jak duszenie, aby stało się miękkie. Często wykorzystywane do przygotowania dań takich jak osso buco.
              </p>
              <img onLoad={Changing4} src={shank} alt="czesc miesa" id="shank"/>
            </Row>
            <hr/>
            <Row className='Info'>
              <h5><a href='#Contact'>Zainteresowany? Skontaktuj się z nami i poznaj szczegóły!</a></h5>
            </Row>
          </section>
        </article>
      </article>
    </>
  );
}



/*========================================
        Functions!!!
=========================================*/

function LinkToContact() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Contact');
  };

  return (
    <button onClick={handleClick}>O nas</button>
  );
}

function LinkToProducts() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Products');
  };

  return (
    <button onClick={handleClick}>Produkty</button>
  );
}


/*========================================
        Header!!!
=========================================*/

function Header(){
  return (
    <>
    {/*====Header====*/}
    <header>
      <Row className='p-4'>
        {/*----Logo----*/}
        <Col xl={8} lg={7} md={6}>
          <div className='Logo'>
              <Link to="/" reloadDocument={true}>
                <Row>
                  <Col lg={1} md={2} xs={2} className='log'>
                    <img src={logo} alt='logo' />
                  </Col>
                  <Col  lg={10} md={9} xs={9} className='log textlog'>
                    Beskidzkie Stado
                  </Col>
                </Row>
              </Link>
          </div>
        </Col>
        {/*----Tabs----*/}
        <Col xl={4} lg={5} md={6} className='log'>
          <Row className='Tabs'>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#About' >
                <LinkToContact />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Products'>
                <LinkToProducts />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Contact'>
                <button>Kontakt</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
                <Link to="/blog" reloadDocument = {true}>
                  <button>Blog</button>
                </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </header >
    </>
  );
}



/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer({Changing4}) {
  return (
    <>
      <section className='footer'>
        <Row className='MiniGallery'>
          {/*-short gallery-*/}
          <Col lg={6} md={12} xs={12} className='mincol'>
            <section className='stadko'>
              {/*-logo-*/}
              <div className='FooterLogo'>
                <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                  <Row>
                    <Col lg={2} md={1} xs={2} className='logoFooter'>
                      <p>
                        <img src={logo} alt='logo' />
                      </p>
                    </Col>
                    <Col lg={10} md={11} xs={10} className='logoFooter'>
                      <h2>Beskidzkie Stado</h2>
                    </Col>
                  </Row>
                </a>
              </div>
              {/*-photos-*/}
              <div className='smallGallery'>
                <Row>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing4} src={mu6} alt="Cow" id="mu6"/>
                    </a>  
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing4} src={mu4} alt="Cow" id="mu4"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing4} src={mu3} alt="Cow" id="mu3"/>
                    </a>
                  </Col>
                </Row>
                <Row className='tooff'>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing4} src={mu2} alt="Cow" id="mu2"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing4} src={mu5} alt="Cow" id="mu5"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing4} src={mu1} alt="Cow" id="mu1"/>
                    </a>
                  </Col>
                </Row>
              </div>
            </section>
          </Col>
          {/*-Contact-*/}
          <Col lg={6} md={12} xs={12}  className='mincol'>
              <section className='contact' id='Contact'>
                <div>
                  <h2>Kontakt</h2>
                </div>
                <section className='links'>
                  {/*-phone-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='tel:+48 532 233 916'>
                        <img src={social2} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <span>+48 532 233 916</span>
                    </Col>
                  </Row>
                  {/*-instagram-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <img src={social3} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <span>Beskidzkie_stado</span>
                      </a>
                    </Col>
                  </Row>
                </section>
            </section>
          </Col>
        </Row>
        {/*-Copyright-*/}
        <Row>
          <Col lg={12} md={12} xs={12} className='copyright'>
            <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
          </Col>
        </Row>
      </section>
    </>
  );
}




function Meat() {

  const [loadedCount4, setLoadedCount4] = useState(null);

  const Changing4 = () => {
    setLoadedCount4(prev => {
      const NewCount4 = prev + 1;
      if (NewCount4 === 13) {
        setTimeout(() => {
          console.log("Iaam loading better quality photos now");
  
          const swap = (id, src) => {
            const el = document.getElementById(id);
            if (el) el.src = src;
            else console.warn(`${id} not found in DOM`);
          };
  
          swap("chuck", chuckh);
          swap("brisket", brisketh);
          swap("flank", flankh);
          swap("lion", lionh);
          swap("plate", plateh);
          swap("rib", ribh);
          swap("round", roundh);
          swap("shank", shankh);
          swap("mu1", mu1h);
          swap("mu2", mu2h);
          swap("mu3", mu3h);
          swap("mu4", mu4h);
          swap("mu5", mu5h);
          swap("mu6", mu6h);
  
        }, 2000);
        console.log(loadedCount4);
      }
      return NewCount4;
    });
  };

    return (
        <>
          <Header />
          <Middle Changing4={Changing4}/>
          <Footer Changing4={Changing4}/>
        </>
    ); 
}

export default Meat;